// extracted by mini-css-extract-plugin
export default {"area":"_024b686a3b2809c2","dragging":"ebabb2bae762264f","text":"e76f7120d67ab678","icon":"_94bffb360476e547"};